<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false" on-slide-changed="slideChange($index)">

      <slide>
        <div class="padding">
          <p>As the sun moves overhead I become slowly more confident of my steps, the ground beneath my feet becomes a reassurance.
          Passers by congregate here, their coats open, smiling in the spring sun. No words, not as far as I can hear. They walk together for companionship, one reaches into a pocket, inside the coat and pulls out a small package bound together. This act is not unnoticed by his nearest companion. He holds his hand out and takes the package. I watch as the recipient unwraps the package, placing the string tying it together inside his coat, and opens a small, folded object.
          I reach inside my own coat and take hold of the paper-wrapped parcel nestled there. I hadn't noticed its existence until this moment. It is sealed in twine, and emits no sound. I hesitate before untying the bow that binds it together.</p>
      </div>
    </slide>

    <slide>
      <div class="padding">
        <p>
          I have no idea how long I have been carrying it.
        </p>
     </div>
    </slide>

    <slide>
      <div class="padding">
        <p fade-click="boxwatch" speed="medium">
          I read the book in my hands.<br>
          I turn the pages and trace words, describing a city that is not the one I hear around me, it reads like fiction, like imagination.<br>
          And yet each place, each name and turn of phrase, all of them hook something in me as if trying to drag up memories from below dark water. <br>
          There are gaps in the pages, and there are sections that have been erased or hidden<br>
          I fold the hard covers and begin walking again,<br>
          my fingers running over the slits in the spine, <br>
          and i think about gaps, <br>
          and about what's <a href="#">between them</a><br></p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
       </div>
      </slide>

    </carousel>
  </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>
